import './AboutChild.css';
import { useEffect, useState } from 'react';
import PopUp from "./PopUp/PopUp";
import closeBtn from "../../image/CloseBlack.svg";

import { useSelector } from "react-redux";

import TextField from '@mui/material/TextField'

import aiIcon from '../../image/stars.svg';
import copyIcon from '../../image/files.svg';
import checkboxIcon from '../../image/check2.svg';

function AboutChild(props) {
    const [displayPopUp, setDisplayPopUp] = useState({ save: false, clear: false });
    const sessionProfile = useSelector((state) => state.session.profile);
    const [buttonIcon, setButtonIcon] = useState(copyIcon);
    const [buttonText, setButtonText] = useState('Скопировать колесо');
    const {
        exportingFor,
        inputData,
        setInputData,
        visibleSliderBlock,
        setDefaultInputData,
        teacherName,
        setTeacherName,
        teacherId,
        setTeacherId,
        canSave,
        saveContext,
        selectedChildId,
    } = props;

    useEffect(() => {
        const textarea = document.querySelectorAll(".textarea");
        textarea.forEach((item) => {
            item.addEventListener("input", function () {
                this.style.height = "auto";
                this.style.height = this.scrollHeight + "px";
            })
        })
    }, []);

    useEffect(() => {
        const sid = sessionProfile?.teacher_id || null;
        if (typeof setTeacherId === 'function') {
            setTeacherId(sid);
        }

        if (sessionProfile?.fio && typeof setTeacherName === 'function') {
            setTeacherName(
                sid ? removeOccurrence(sessionProfile.fio, sid) : sessionProfile.fio
            );
        }
    }, [sessionProfile, setTeacherId, setTeacherName]);

    const handleChange = (event) => {
        setInputData(prevState => ({ ...prevState, [event.target.name]: event.target.value }));
    };

    const openPopUp = (name) => {
        setDisplayPopUp(prevState => ({ ...prevState, [name]: true }));
        document.body.style.overflow = 'hidden';
    };

    const saveEnabled = Boolean(
        canSave ??
        (visibleSliderBlock?.direction &&
            visibleSliderBlock?.dateBirth &&
            selectedChildId)
    );

    return (
        <div className='about-child'>
            <div className='about-child-info' export-ignore={(exportingFor === 'parent').toString()}>
                <h2>О ребёнке</h2>
                <Textaria data={dataImport.about} inputData={inputData} handleChange={handleChange} />
            </div>
            <div className='about-child-info'>
                <h2>Комментарии и пожелания</h2>

                <div className='textaria-container' export-ignore={(exportingFor === 'parent').toString()}>
                    <TextField
                        label="Комментарий/цель от родителя"
                        name="parent_comment"
                        value={inputData.parent_comment}
                        onChange={handleChange}
                        id="parent_comment"
                        variant="filled"
                        fullWidth
                        multiline
                        slotProps={{
                            input: {
                                disableUnderline: true,
                            },
                            htmlInput: {
                                'data-copy-bot': 'Комментарий родителя',
                            }
                        }}
                    />
                </div>
                <div className='textaria-container' export-ignore={(exportingFor === 'parent').toString()}>
                    <TextField
                        label="Как прошел урок"
                        name="lesson_comment"
                        variant="filled"
                        value={inputData.lesson_comment}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        slotProps={{
                            input: {
                                disableUnderline: true,
                            }
                        }}
                    />
                </div>
                <div className='copybot-container'>
                    <p className='copybot-text'>Цели можно получить с помощью&nbsp;
                        <img src={aiIcon} alt='star' />&nbsp;
                        <a href='https://app.pachca.com/chats?user_id=763943' target='_blank' rel='noreferrer'>AI-бота</a>.
                        Нажмите кнопку «Скопировать колесо», вставьте данные в бота — и он пришлёт готовые цели.
                    </p>
                    <button className='copybot-button' onClick={(e) => handlerCopy(e, setButtonIcon, setButtonText)}>
                        <img src={buttonIcon} alt='copyIcon' />
                        {buttonText}
                    </button>
                </div>
                <div className='textaria-container'>
                    <TextField
                        label='Цели на ближайший месяц'
                        name="month_goals"
                        id="month_goals"
                        variant="filled"
                        value={inputData.month_goals}
                        onChange={handleChange}
                        helperText="Это поле увидят родители в личном кабинете"
                        fullWidth
                        multiline
                        slotProps={{
                            input: {
                                disableUnderline: true,
                            }
                        }}
                    />
                </div>
                <div className='about-child-accept'>
                    <p>Ваш заботливый учитель</p>
                    <input
                        type='text'
                        id="teacher-name"
                        className="inputTeacher"
                        name="teacher_name"
                        placeholder='Ваше имя и фамилия'
                        value={teacherName || ''}
                        onChange={(e) => {
                            if (typeof setTeacherName === 'function') {
                                setTeacherName(e.target.value);
                            }
                        }}
                        autoComplete="off"
                    />
                </div>
                <div className='button2'>
                    <button
                        export-ignore='true'
                        id='save-data-child'
                        disabled={!saveEnabled}
                        onClick={() => openPopUp('save')}
                    >
                        Сохранить как новую версию
                    </button>

                    <button className='drop-value-text drop-button' onClick={() => openPopUp('clear')}>Сбросить текст</button>

                </div>

            </div>
            {displayPopUp.clear && <AlertPopUp setDisplayPopUp={setDisplayPopUp} setDefaultInputData={setDefaultInputData} />}
            {displayPopUp.save && (
                <PopUp
                    setDisplayPopUp={setDisplayPopUp}
                    saveContext={{
                        ...saveContext,
                        teacherId,
                        teacherName,
                    }}
                />
            )}
        </div>
    )
}

export default AboutChild;


function Textaria(props) {
    const { data, inputData, handleChange } = props;
    return data.map((item, index) => (
        <div className='textaria-container' key={index}>
            <TextField
                label={item.value}
                name={item.name}
                value={inputData[item.name]}
                onChange={handleChange}
                variant="filled"
                fullWidth
                multiline
                slotProps={{
                    input: {
                        disableUnderline: true,
                    },
                    htmlInput: {
                        'data-copy-bot': item.value,
                    }
                }}
            />
        </div>
    ))
}

function AlertPopUp(props) {
    const { setDisplayPopUp, setDefaultInputData } = props;

    function handleClose(e) {
        if (e.target.id === "popup") {
            setDisplayPopUp(prevState => ({ ...prevState, clear: false }));
            document.body.style.overflow = 'auto';
        }
    }

    function handleClick() {
        setDisplayPopUp(prevState => ({ ...prevState, clear: false }));
        document.body.style.overflow = 'auto';
    }

    return (
        <div className="popup" id="popup" onClick={(e) => handleClose(e)}>
            <div className="popup-content">
                <div className="popup-close-button">
                    <img src={closeBtn} alt="closeBtn" onClick={handleClick} />
                </div>
                <p>Вы действительно хотите сбросить текст?</p>
                <button onClick={() => { setDefaultInputData(); handleClick(); }}>Сбросить</button>
                <button className="back-to-edit" onClick={handleClick}>Нет</button>
            </div>
        </div>
    )
}

function removeOccurrence(str, pattern) {
    let index = str.indexOf(pattern);
    if (index !== -1) {
        str = str.slice(index + pattern.length + 1);
    }
    return str;
}

const dataImport = {
    about: [
        {
            value: 'Интересы ребёнка/как увлечь',
            name: 'interests'
        },
        {
            value: 'Любимые персонажи',
            name: 'favorite_characters'
        },
        {
            value: 'Что любит / что не любит',
            name: 'likes_dislikes'
        },
    ],
    comment: [
        {
            value: 'Комментарий/цель от родителя',
            name: 'parent_comment'
        },
        {
            value: 'Цели на ближайший месяц',
            name: 'month_goals'
        },
        {
            value: 'Как прошел урок',
            name: 'lesson_comment'
        }
    ]
}

function handlerCopy(event, setButtonIcon, setButtonText) {
    const idClientChildCopy = document.getElementById('name-child');
    const ageChlildCopy = document.getElementById('date-birth');

    const inputCopy = document.querySelectorAll('input[data-copy-bot]');
    const textareaCopy = document.querySelectorAll('textarea[data-copy-bot]');
    const directionCopy = document.querySelector('p[data-copy-bot]');

    const idChild = idClientChildCopy.getAttribute('data-child-id');
    const idClient = idClientChildCopy.getAttribute('data-client-id');


    let resultString = '';

    resultString += `
    ID ребенка: ${idChild}
ID клиента: ${idClient}
Возраст ребенка: ${ageChlildCopy.textContent}\n
Направление: ${directionCopy.textContent};\n`;

    textareaCopy.forEach((item) => {
        const attribute = item.getAttribute('data-copy-bot');

        resultString += `${attribute}: ${item.value};\n`;

    });
    resultString += `\nКолесо баланса:\n`;

    inputCopy.forEach((item) => {
        const attribute = item.getAttribute('data-copy-bot');
        resultString += `${attribute} - ${item.value}\n`;
    });

    navigator.clipboard.writeText(resultString.trim())
        .then(() => {
            setButtonIcon(checkboxIcon);
            setButtonText('Скопировано')
            event.target.classList.add('button-active');

            setTimeout(() => {
                setButtonIcon(copyIcon);
                event.target.classList.remove('button-active');
                setButtonText('Скопировать колесо');
            }, 2000);
        })
        .catch(err => {
            console.error('Ошибка при копировании текста: ', err);
        });
}
